import { Component, OnInit } from '@angular/core';
import { ShuttleComponent } from '../shuttle/shuttle.component';
import {CookieService} from 'angular2-cookie/core';
import {Router} from "@angular/router";
import { shuttleService } from '../data/shuttle.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-shuttle-login',
  templateUrl: './shuttle-login.component.html',
  styleUrls: ['./shuttle-login.component.css']
})
export class ShuttleLoginComponent extends ShuttleComponent implements OnInit{

     constructor(private c_cookieService:CookieService,private c_router: Router, private c_shuttleService:shuttleService,private c_location:Location) {
          super(c_cookieService,c_router,c_shuttleService,c_location);
          //this.init();
     }

     ngOnInit(){
          super.ngOnInit()
          console.log('login ngOnInit');
          let td = parseInt(this.get_cookie('app_driver'));
          console.log(td);
          if(td > 0){
               this.save_cookie('app_driver',0);
          }

     }


 }
